import React from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { Link } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

class PasswordReset extends React.Component {

    constructor() {
        super();

        this.state = {
            isTokenValid: false,
            tokenHasBeenChecked: false,
            wrongPasswordLabelShouldBeSeen: false,
        }
    }

    render() {
        return (
            <React.Fragment>
                <p>Recuperación de contraseña</p>

                {this.getPasswordSetForm()}
                {this.getWrongTokenLabel()}
                {this.getCheckingTokenLabel()}

                <div style={{ width: "100%", textAlign: "right" }}>
                    <Typography variant="body2" color="textSecondary" align="right"
                        style={{ fontSize: 10, paddingRight: 15 }}>
                        <Link color="inherit" href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.history.push("/auth/login");
                            }}>
                            <b>Volver al inicio</b>
                        </Link>
                    </Typography>
                </div>

            </React.Fragment>
        );
    }

    componentDidMount(){
        const urlParams = new URLSearchParams(window.location.search);
        const targetEmail = urlParams.get("user");
        const resetToken = urlParams.get("token");

        if(resetToken && targetEmail){this.checkTokenFromBackend(resetToken,targetEmail);}
        else{this.props.history.push("/auth/login");}
    }

    //Métodos para renderizado:
    getCheckingTokenLabel = () => {
        if (!this.state.tokenHasBeenChecked) {
            return (
                <div style={{ textAlign: "center", paddingTop: "10vh", paddingBottom: "10vh" }}>
                    <p>Hola, <b>diego.torres@fitideas.co</b></p>
                    <p>Estamos validando el token de <b>recuperación de contraseña</b>.
                    Por favor, espera un momento...</p>
                </div>
            );
        }
    }

    getPasswordSetForm = () => {
        if (this.state.isTokenValid) {
            return (
                <form className={this.props.classes.form} onSubmit={(e) => {
                    e.preventDefault();
                    this.setState({ wrongPasswordLabelShouldBeSeen: false });
                    this.passwordChangeOnSubmit(e);
                }}>
                    <TextField
                        // value="admin@fitideas.co"
                        style={this.props.customFontStyle}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="newPassword"
                        label="Nueva contraseña"
                        name="newPassword"
                        type="password"
                        autoFocus />

                    <TextField
                        // value="admin@fitideas.co"
                        style={this.props.customFontStyle}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="newPasswordCheck"
                        label="Repite tu nueva contraseña"
                        name="newPasswordCheck"
                        type="password"/>

                    <p style={{ marginBottom: 0, marginLeft: 15, color: "red" }}
                        hidden={!this.state.wrongPasswordLabelShouldBeSeen}>
                        Las contraseñas no coinciden...
                    </p>

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={this.props.classes.submit}>
                        Confirmar nueva contraseña
                    </Button>
                </form>
            );
        }
    }

    getWrongTokenLabel = () => {
        if (!this.state.isTokenValid && this.state.tokenHasBeenChecked) {
            return (
                <div style={{ textAlign: "center", paddingTop: "10vh", paddingBottom: "10vh" }}>
                    <p>Al parecer el token de recuperación de contraseña <b>ya expiró</b>.</p>
                    <p>Debes generar uno nuevamente desde la pantalla de inicio.</p>
                </div>
            );
        }
    }

    //Métodos operativos:
    checkTokenFromBackend = (resetToken, targetEmail) => {
        fetch(process.env.REACT_APP_API_URL + '/users/validateResetToken', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'email': targetEmail, 'token': resetToken })
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        serverResponse.json()
                            .then(tokenStatus => {
                                this.setState({
                                    isTokenValid: tokenStatus,
                                    tokenHasBeenChecked: true,
                                });
                            });
                        break;

                    default:
                        console.log("Error desconocido validando el token...");
                        this.setState({isTokenValid: false,tokenHasBeenChecked: true,});
                        break;
                }
            })
            .catch(error => { console.log(error); })
    }

    passwordChangeOnSubmit = (e) => {
        if (e.target.newPassword.value === e.target.newPasswordCheck.value) {
            this.setNewPasswordFromBackend(e.target.newPassword.value);
        }
        else { this.setState({ wrongPasswordLabelShouldBeSeen: true }); }
    }

    setNewPasswordFromBackend = (newPassword)=>{
        const urlParams = new URLSearchParams(window.location.search);
        const targetEmail = urlParams.get("user");
        const resetToken = urlParams.get("token");

        fetch(process.env.REACT_APP_API_URL + '/users/setNewPassword', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'email': targetEmail, 'token': resetToken, 'new_password': newPassword })
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        this.fireSuccessPasswordChangeAlert();
                        break;

                    default:
                        this.fireFailedPasswordChangeAlert();
                        break;
                }
            })
            .catch(error => { console.log(error); })
    }

    //Métodos relacionados con SweetAlert:
    fireFailedPasswordChangeAlert = () => {
        Swal.fire('Proceso fallido', 'Se presentó un error crítico en el <b>cambio de contraseña</b>. Intenta más tarde.', 'error')
            .then(() => {  });
    }

    fireSuccessPasswordChangeAlert = () => {
        Swal.fire('Proceso exitoso', 'Ya puedes utilizar tu <b>nueva contraseña</b> para iniciar sesión', 'success')
            .then(() => { this.props.history.push("/auth/login"); });
    }
}

const mapStateToProps = state => {
    return {
        coreBackendHost: state.mainReducer.coreBackendHost,
    };
};

export default connect(mapStateToProps)(withRouter(PasswordReset));